import type { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { env } from '@/config/env';

// PKCE is disabled because the web-api owns the code-exchange (UC-16 §2):
// the SPA receives the authorisation code on /auth/callback and forwards it to
// `POST /auth/sso/complete`; the web-api calls Google's token endpoint with
// its server-side `client_secret`. With PKCE on, Google would require
// `code_verifier` on the token request, which only lives in the SPA's
// localStorage and would defeat the BFF pattern.
//
// `skipSigninCallback` is set on `<AuthProvider>` (in App.tsx) for the
// `/auth/callback` path so the library doesn't auto-exchange the code in
// the browser — `AuthCallbackPage` handles it.
export const oidcConfig: AuthProviderProps = {
  authority: env.VITE_OIDC_AUTHORITY,
  client_id: env.VITE_OIDC_CLIENT_ID,
  redirect_uri: env.VITE_OIDC_REDIRECT_URI,
  post_logout_redirect_uri: env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI,
  scope: env.VITE_OIDC_SCOPE,
  response_type: 'code',
  disablePKCE: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: false,
};
